import { Box, Link, Stack, Typography } from "@mui/material";

const renderBlock = (block, index) => {
  switch (block.type) {
    case "h1":
      return (
        <h1 key={index} style={{ textAlign: "center", marginBottom: "1rem" }}>
          {block.text}
        </h1>
      );
    case "underline":
      return (
        <Typography key={index} style={{ textDecoration: "underline" }}>
          {block.text}
        </Typography>
      );
    case "heading":
      return (
        <Typography key={index} fontWeight={600}>
          {block.text}
        </Typography>
      );
    case "link":
      return (
        <Typography key={index}>
          <Link href={block.href} target="_blank" rel="noopener noreferrer">{block.text}</Link>
        </Typography>
      );
    default:
      return <Typography key={index}>{block.text}</Typography>;
  }
};

const LegalDocumentPage = ({ content }) => {
  return (
    <Stack display="flex" justifyContent="center">
      <Box
        boxSizing="border-box"
        sx={{
          maxWidth: "md",
          padding: "1rem",
          margin: "1rem",
        }}
      >
        <Stack spacing="1rem">{content.map(renderBlock)}</Stack>
      </Box>
    </Stack>
  );
};

export default LegalDocumentPage;
